<template>
  <div>
    <div class="card">
      <div class="card-header">Notas de Despesas da Fonte Pagadora (Funcionários)</div>
      <div class="card-body">
        <b-tabs>
          <!-- <b-tab title="ND em aberto da Fonte Pagadora" active>
            <NDEmployeesOpen></NDEmployeesOpen>
          </b-tab> -->
          <b-tab title="Todas Notas de Despesas da Fonte Pagadora">
            <NDEmployeesAll></NDEmployeesAll>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import NDEmployeesAll from './NDEmployeesAll';
import NDEmployeesOpen from './NDEmployeesOpen';

export default {
  components: {
    NDEmployeesAll,
    NDEmployeesOpen,
  }
}

</script>
